<template>
  <div>
    <div>
      <p>Сальдо прошлого дня:</p>
      <p v-for="balance in getCurrencyBalance(balance.start)">
        <span v-if="balance.currency">{{ balance.currency }}: </span>
        <strong>{{ balance.balance.toLocaleString("ru-RU") }}</strong>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['currencyId', 'currentCurrencyId', 'incomes', 'expenses', 'balance'],
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    }
  },
  methods: {
    getCurrencyBalance(balance) {
      const currencyQty = Object.values(balance).filter((b) => b.orders).length;
      const arr = [];
      Object.keys(balance).forEach((curr) => {
        let data = {};
        if (balance[curr].orders) {
          if (currencyQty > 1) data.currency = this.$AllCurrencies[curr].currency;
          let rate = 1
          if (+this.currencyId !== +curr){

          }
          data.balance = balance[curr].orders;
        }
        if (data.balance) arr.push(data);
      })
      if (!arr.length) arr.push({balance: 0});
      return arr;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
